import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';

function deleteConnectedApplicationsSecretRequestConfig(appId: string, secretId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'DELETE',
    endpoint: 'connected-applications/' + appId + '/secrets/' + secretId,
    serverWideRequest: false
  };
}

export function callDeleteConnectedApplicationsSecret(appId: string, secretId: string) {
  return makeJsonRestApiRequest<void, IResult>({
    config: deleteConnectedApplicationsSecretRequestConfig(appId, secretId),
    request: null,
  });
}